import Immutable from 'immutable';
import type { Map } from 'immutable';
import type { AnyAction } from 'redux';
import { GET_CANCELLATIONS } from './actions';

interface DropsStateShape {
  loading: Record<string, boolean>;
  data: Record<string, unknown>;
  errorMessage: Record<string, string>;
}

type DropsState = Map<string, unknown>;

export function dropsReducer(
  state: DropsState = Immutable.fromJS({
    loading: {},
    data: {},
    errorMessage: {},
  }) as DropsState,
  action: AnyAction,
): DropsState {
  const jsState = state.toJS() as DropsStateShape;
  const { data, loading, errorMessage } = jsState;

  const key = `${action.hours}-${action.factor}-${action.tableType}-${action.productFilter}`;

  switch (action.type) {
    case `${GET_CANCELLATIONS}_LOADING`: {
      data[key] = undefined;
      loading[key] = true;
      delete errorMessage[key];

      return state.merge({ data, loading, errorMessage });
    }
    case `${GET_CANCELLATIONS}_ERROR`: {
      data[key] = undefined;
      loading[key] = false;
      errorMessage[key] = JSON.stringify(action);

      return state.merge({ data, loading, errorMessage });
    }
    case GET_CANCELLATIONS: {
      data[key] = action.data;
      loading[key] = false;
      delete errorMessage[key];

      return state.merge(
        Immutable.fromJS({
          data,
          loading,
          errorMessage,
        }),
      );
    }

    default: {
      return state;
    }
  }
}
